/**
 * Empty-state switch for an email account tab (AM-1107).
 *
 * `checkAction` is an emailHub action that resolves to whether the account
 * has anything set up for the feature. Until it answers the tab shows a loader;
 * when it says no, only FeatureSetup shows, and its button flips `setUp` so
 * the tab's normal create form and table take over for the rest of the visit.
 *
 * A failed check counts as "set up": the full tab still works, while a wrong
 * empty state would hide items the customer has.
 */
export default (checkAction) => ({
  data () {
    return {
      setUp: null, // null while checking
    }
  },
  methods: {
    async checkSetUp () {
      this.setUp = null
      try {
        this.setUp = await this.$store.dispatch(`emailHub/${checkAction}`, this.service.id)
      } catch (e) {
        console.warn(`emailFeatureSetup: ${checkAction} failed`, e)
        this.setUp = true
      }
    },
    startSetUp () {
      this.setUp = true
    },
  },
  watch: {
    'service.id' () {
      this.checkSetUp()
    },
  },
  created () {
    this.checkSetUp()
  },
})
